var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgError = function SvgError(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    fillRule: "evenodd",
    d: "M1.601 11.266a2.53 2.53 0 0 1 0-2.532L4.702 3.36a2.54 2.54 0 0 1 2.194-1.266H13.1c.907 0 1.74.482 2.193 1.266L18.4 8.734a2.52 2.52 0 0 1 0 2.532l-3.1 5.375a2.54 2.54 0 0 1-2.195 1.266H6.9a2.53 2.53 0 0 1-2.194-1.266zm9.022-.013H9.378c-.24 0-.435-.2-.45-.443L8.672 5.5a.466.466 0 0 1 .45-.5h1.755c.255 0 .465.228.45.5l-.255 5.31a.463.463 0 0 1-.45.443m.877 2.184c0 .856-.675 1.563-1.5 1.563s-1.5-.7-1.5-1.563c0-.857.675-1.556 1.5-1.556.803 0 1.47.664 1.5 1.556",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgError);
export default ForwardRef;